export default {
  namespaced: true,

  state: {
    teachers: [],
    requestsToLesson: [],
    lessonTypes: [],
    students: []
  },

  getters: {
    getTeachers: state => state.teachers,
    getRequestsToLesson: state => state.requestsToLesson,
    getLessonTypes: state => state.lessonTypes,
    getStudents: state => state.students
  },

  mutations: {
    SET_OBJECT(state, [namespace, data]) {
      state[namespace] = { ...data };
    },
    SET_ARRAY(state, [namespace, data]) {
      state[namespace] = [...data];
    },
    SET_TEACHERS(state, data) {
      const teachers = [];

      data.teachers.forEach(t => {
        const lessons = [];
        data.slots.forEach(slot => {
          const index = t.lessons.findIndex(l => slot.start === l.start);
          if (index > -1) {
            lessons.push({
              ...slot,
              ...t.lessons[index],
              lesson_id: t.lessons[index].id,
              slot_id: slot.id
            });
          } else {
            lessons.push({
              teacher_id: t.id,
              teacher_skills: t,
              ...slot,
              slot_id: slot.id,
              empty: true
            });
          }
        });
        t.lessons = [...lessons];
        teachers.push(t);
      });
      state.teachers = [...teachers];
    }
  },

  actions: {
    async fetchTeachers({ commit }, params) {
      const { data } = await this.$service.retrieve(
        this.$services.common.teachers,
        {
          params
        }
      );
      commit('SET_TEACHERS', data);
    },
    async fetchRequestsToLesson({ commit }, params) {
      const { data } = await this.$service.retrieve(
        this.$services.studyCenter.requestToLesson,
        { params }
      );
      commit('SET_ARRAY', ['requestsToLesson', data || []]);
    },
    async fetchLessonTypes({ commit }, params) {
      const res = await this.$service.retrieve(
        this.$services.studyCenter.lessonTypes,
        { params }
      );
      commit('SET_ARRAY', [
        'lessonTypes',
        res.data.map(d => ({ ...d, text: d.name }))
      ]);
    },
    async fetchStudents({ commit, rootState }, params) {
      const res = await this.$service.retrieve(
        this.$services.studentList.students,
        {
          params
        }
      );
      const students = res.data.data.map(s => ({
        ...s.user,
        id: s.user.id,
        user_id: s.user.id,
        student_id: s.id,
        class_name: s.student_class?.class_name,
        group_name: s.group?.name
      }));
      commit('SET_ARRAY', ['students', students]);
    }
  }
};
